import styled from '@emotion/styled'

export const SelectFieldWrapper = styled.div`
  position: relative;
`

export const NativeSelect = styled.select`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
`

export const SelectTrigger = styled.button<{ $invalid?: boolean }>`
  display: flex;
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 2px solid ${({ $invalid }) => ($invalid ? '#e53935' : '#596170')};
  border-radius: 6px;
  outline: none;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #202327;
  background: #fff;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 16px;
  cursor: pointer;
  text-align: left;

  &:hover:not(:disabled) {
    border-color: #7d8798;
  }

  &:focus-visible {
    border-color: #ff8e00;
    box-shadow: 0 0 0 3px rgba(255, 142, 0, 0.2);
  }

  &:disabled {
    color: #717782;
    background: #d9dce1;
    cursor: not-allowed;
  }
`

export const SelectChevron = styled.span<{ $open?: boolean }>`
  width: 9px;
  height: 9px;
  border-right: 2px solid #353c4b;
  border-bottom: 2px solid #353c4b;
  flex: 0 0 auto;
  transform: ${({ $open }) =>
    $open ? 'rotate(225deg) translate(-2px, -2px)' : 'rotate(45deg)'};
  transition: transform 150ms ease;
`

export const SelectList = styled.ul`
  position: absolute;
  z-index: 30;
  top: calc(100% + 7px);
  right: 0;
  left: 0;
  padding: 6px;
  border: 1px solid #4c5669;
  border-radius: 9px;
  margin: 0;
  background: #20252e;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.38);
  list-style: none;
`

export const SelectOption = styled.li<{
  $active?: boolean
  $selected?: boolean
}>`
  display: flex;
  min-height: 42px;
  padding: 8px 11px;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ $selected }) => ($selected ? '#fff' : '#e5e8ee')};
  background: ${({ $active, $selected }) => {
    if ($active) return '#533bff'
    if ($selected) return 'rgba(255, 142, 0, 0.2)'
    return 'transparent'
  }};
  box-sizing: border-box;
  cursor: pointer;
  font-size: 15px;
  line-height: 1.3;

  &:hover {
    color: #fff;
    background: #533bff;
  }

  &[aria-disabled='true'] {
    color: #717782;
    cursor: not-allowed;
    background: transparent;
  }
`

export const SelectCheck = styled.span`
  width: 7px;
  height: 13px;
  border-right: 2px solid #ff8e00;
  border-bottom: 2px solid #ff8e00;
  margin-right: 4px;
  flex: 0 0 auto;
  transform: rotate(45deg);
`
